import { Component } from "@angular/core";
import { BnLoadingService, MessageChannelService, messageLevel } from "@bndes/bndes-ux4/bndes-angular-utils";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { NotasService } from "src/app/features/notas/notas.service";
import { AgenteFinanceiro } from "src/app/model/agente-financeiro.model";
import { NotaOperacaoGarantida, TIPO_CLASSE_OPERACAO } from "src/app/model/nota.model";
import Utils from "src/app/shared/fgi-utils";


@Component({
    templateUrl: 'desabilitar-nota-popup.component.html',
    standalone: false
})
export class DesabilitarNotaPopUpComponent {
    public nota: NotaOperacaoGarantida;
    public agentes: AgenteFinanceiro[];
    public classesOperacao = TIPO_CLASSE_OPERACAO;

    constructor(private activeModal: NgbActiveModal,
        private messageService:MessageChannelService,
        private notasService: NotasService,
        private loadingService: BnLoadingService) {
    }

    nomeAgenteFinanceiro(id: number) {
        return Utils.nomeAgentePorId(id, this.agentes);
    }

    fechar() {
        this.activeModal.close();
    }

    confirmaDesativacao() {
        this.loadingService.bloqueiaTela();
        this.nota.ativo = 'N';
        this.notasService
        .save(this.nota)
        .subscribe(resultado =>{
            this.loadingService.liberaTela()
            this.fechar()
            this.messageService.addMessage({
                title: 'Sucesso',
                type: 'CRUD_OPERATION',
                level: messageLevel.SUCCESS,
                message: 'Nota desativado com sucesso.'
            })
        });
           
    }
}
